import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/onBoardings'

export default {
  async getAllRequested(filter) {
    return await axios
      .get(endpoint + `/list/demanded${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAllApproved(filter) {
    return await axios
      .get(endpoint + `/list/approved${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAllRejected(filter) {
    return await axios
      .get(endpoint + `/list/rejected${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getById(candidateId) {
    return await axios
      .get(endpoint + `/item/${candidateId}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async viewProviderDocument(documentId) {
    return await axios
      .get(endpoint + `/item/document/provider/${documentId}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async viewDriverDocument(providerCandidateId, documentId) {
    return await axios
      .get(endpoint + `/item/document/driver/${providerCandidateId}/${documentId}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async viewVehicleDocument(providerCandidateId, documentId) {
    return await axios
      .get(endpoint + `/item/document/vehicle/${providerCandidateId}/${documentId}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async resendEmail(request) {
    return await axios
      .post(endpoint + '/email', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async fullyApprove(request) {
    return await axios
      .put(endpoint + '/approve', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async fullyReject(request) {
    return await axios
      .put(endpoint + '/reject', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async approveProviderDocument(request) {
    return await axios
      .put(endpoint + '/approve/provider', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async approveDriverDocument(request) {
    return await axios
      .put(endpoint + '/approve/driver', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async approveVehicleDocument(request) {
    return await axios
      .put(endpoint + '/approve/vehicle', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async rejectProviderDocument(request) {
    return await axios
      .put(endpoint + '/reject/provider', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async rejectDriverDocument(request) {
    return await axios
      .put(endpoint + '/reject/driver', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async rejectVehicleDocument(request) {
    return await axios
      .put(endpoint + '/reject/vehicle', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async sendMandatoryDocument(request) {
    return await axios
      .post(endpoint + '/email/document', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/onboarding/onBoardingService.js